/** One piece of a search result's text, flagged when it is one of the searched words. */
export type HighlightSegment = { text: string; match: boolean };

function escapeRegExp(raw: string): string {
  return raw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Splits `text` around every case-insensitive occurrence of `terms` (FR-517). Terms come from the
 * search API, so the words lit up are the ones the server matched on. Longer terms win where two
 * overlap, so "street" is marked whole rather than only its "st".
 */
export function highlightSegments(text: string, terms: readonly string[]): HighlightSegment[] {
  if (!text) return [];
  const usable = [...new Set(terms.map((term) => term.trim()).filter(Boolean))].sort(
    (a, b) => b.length - a.length,
  );
  if (usable.length === 0) return [{ text, match: false }];

  // A capturing split puts the matched words at the odd positions.
  const pattern = new RegExp(`(${usable.map(escapeRegExp).join('|')})`, 'i');
  return text
    .split(pattern)
    .map((part, index) => ({ text: part, match: index % 2 === 1 }))
    .filter((segment) => segment.text.length > 0);
}
